import { InfoDialogComponent } from '@/components/info-dialog/info-dialog.component';
import { PropertyDocViewComponent } from '@/components/property-doc-view/property-doc-view.component';
import { ObjectUpdatedType } from '@/enums/ObjectUpdatedType.enum';
import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { ActionService } from '@/services/action.service';
import { AppConfigService } from '@/services/app-config.service';
import { NgIf } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { PropertiesService, PropertyCategory, RealProperty } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { PropertyAttributesViewComponent } from '../../../components/property-attributes-view/property-attributes-view.component';
import { PropertyDocViewComponent as PropertyDocViewComponent_1 } from '../../../components/property-doc-view/property-doc-view.component';
import { PropertyPeopleTableComponent } from '../../../components/property-people-table/property-people-table.component';

@Component({
  selector: 'app-property-people',
  templateUrl: './property-people.component.html',
  styleUrls: ['./property-people.component.scss'],
  standalone: true,
  imports: [
    PropertyAttributesViewComponent,
    NgIf,
    PropertyPeopleTableComponent,
    PropertyDocViewComponent_1,
    MatCardModule,
    MatIconModule,
    MatDivider,
    MatButtonModule,
    MatExpansionModule
  ]
})
export class PropertyPeopleComponent implements OnInit, OnDestroy {
  @ViewChild(PropertyDocViewComponent) docComponent: PropertyDocViewComponent;
  @Input() prop: RealProperty;

  subs: Subscription[] = [];

  isPeopleListFeatureAvailable = false;
  category = PropertyCategory.PEOPLE;

  canSeePropertyNotes = false;
  canUpdatePropertyNotes = false;
  propertyNotes = '';

  constructor(
    private propService: PropertiesService,
    private propHelper: PropertyHelper,
    private appConfigService: AppConfigService,
    private dialog: MatDialog,
    private actionService: ActionService,
    private userHelper: UserHelper
  ) {}

  ngOnInit() {
    // Allowed only on types HOUSE, FLAT, FARM
    this.isPeopleListFeatureAvailable =
      this.propHelper.isHouse(this.prop) || this.propHelper.isFlat(this.prop) || this.propHelper.isFarm(this.prop);
    this.subs.push(
      this.appConfigService.objectUpdated.subscribe((type) => {
        if (type === ObjectUpdatedType.DOC) {
          this.refreshDocList();
        }
      })
    );
    this.subs.push(
      this.appConfigService.objectUpdated.subscribe((type) => {
        if (type === ObjectUpdatedType.NOTES) {
          this.loadPropertyNotes();
        }
      })
    );

    this.canSeePropertyNotes = this.userHelper.isAdmin() || this.userHelper.isPropertyOwner(this.prop);
    this.canUpdatePropertyNotes = this.canSeePropertyNotes && this.userHelper.canUpdateProperty(this.prop);
    this.loadPropertyNotes();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  refreshDocList() {
    if (this.docComponent) {
      this.docComponent.loadDocList();
    }
  }

  loadPropertyNotes() {
    // load notes
    if (this.canSeePropertyNotes) {
      this.subs.push(
        this.propService.getRealPropertyPersonalNotes(this.prop.uid).subscribe((n) => {
          if (n && n.notes) {
            this.propertyNotes = n.notes;
          } else {
            this.propertyNotes = "Aucune note n'est renseignée";
          }
        })
      );
    }
  }

  showPropertyNotesInfo() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      this.dialog.open(InfoDialogComponent, {
        maxWidth: '30rem',
        data: {
          title: 'Notes personnelles',
          content:
            '<p>Ces notes sont confidentielles et ne sont visibles que par vous.</p>' +
            "<p>Même si un partage en délégation est effectué, la personne destinataire n'y aura pas accès.</p>" +
            '<p>&nbsp;</p>' +
            '<p>Vous pouvez donc utiliser cet espace pour stocker toute information en lien avec le bien, que vous ne souhaitez pas partager.</p>'
        }
      });
    }
  }

  editNotes() {
    this.actionService.editNotes();
  }
}
